import { render, staticRenderFns } from "./sidebar-static-audience.vue?vue&type=template&id=3c04dcde&scoped=true&"
import script from "./sidebar-static-audience.vue?vue&type=script&lang=js&"
export * from "./sidebar-static-audience.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-static-audience.vue?vue&type=style&index=0&id=3c04dcde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04dcde",
  null
  
)

export default component.exports